<template>
  <div class="pl-5 pr-5 mt-5">
    <div class="title">
      <v-icon class="indent pr-1">mdi-square-medium</v-icon>
      <span class="">Spectu konektor</span>
    </div>

    <div class="font-weight-light mt-3">
      <p>
        Webová aplikace pro propojení iOS aplikace
        <a href="//spectu.com" target="_blank">
          <v-icon>mdi-open-in-new</v-icon>
          <span>Spectu</span>
        </a>
        s databází na serveru. Webová aplikace nemá uživatelské rozhraní, je řešena
        formou speciálního API založeného na architektuře
        <a href="cs.wikipedia.org/wiki/Representational_State_Transfer" target="_blank">
          <v-icon>mdi-open-in-new</v-icon>
          <span>RESTfull</span>
        </a>.
      </p>
      <p>
        Komunikace mezi aplikací
        Spectu (provozována na tabletech Apple iPad) a databází je oboustranná, předávání dat a dotazů zajišťuje
        konektor, který rovněž funguje jako vyrovnávací cache pro data. To znamená, že databáze může kontaktovat
        konektor (na serveru je spuštěna non-stop služba, tzv. daemon) a předat mu nová aktuální data, která jsou
        pak předána na jednotlivé iPady, a stejně tak iPad může kontaktovat konektor a vyžádat si nová data
        nebo zaslat svá data (např. novou objednávku jídel), která jsou doručena do databáze.
      </p>
    </div>
  </div>
</template>

<script>
  export default {
    name: "SpectuConnector"
  }
</script>

<style scoped>
  a {
    color: rgba(8, 113, 0, 0.87);
    text-decoration: none;
  }
  a:hover {
    border-bottom: 1px solid;
  }
  a i {
    font-size: 12px!important;
    margin-left: 2px;
    margin-right: 2px;
    margin-top: 0;
  }
  .indent {
    margin-left: -7px;
    margin-top: -2px;
  }
</style>